"use client"

import { Calendar, CreditCard, FileText, LogIn, UserPlus } from "lucide-react"
import { Button } from "@/components/ui/button"

const JANE_LOGIN_URL = "https://raintree.janeapp.com.au/account"
const JANE_CREATE_ACCOUNT_URL = "https://raintree.janeapp.com.au/validated_users/new"

interface AccountContentProps {
  className?: string
  onClose?: () => void
}

export function LoginIframeContent({ className = "", onClose }: AccountContentProps) {
  const handleLogin = () => {
    window.open(JANE_LOGIN_URL, "_blank")
    onClose?.()
  }

  const handleCreateAccount = () => {
    window.open(JANE_CREATE_ACCOUNT_URL, "_blank")
    onClose?.()
  }

  return (
    <div className={`flex flex-col py-6 px-6 space-y-6 ${className}`}>
      {/* Account Benefits */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-gray-900">
          With a patient account, you can:
        </h3>

        <div className="space-y-4">
          {/* Appointments */}
          <div className="flex gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#848974]/10 flex items-center justify-center">
              <Calendar className="w-4 h-4 text-[#848974]" />
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-900">Manage Appointments</p>
              <ul className="text-sm text-gray-600 space-y-0.5">
                <li>• View upcoming appointments</li>
                <li>• Book, cancel, or reschedule online</li>
                <li>• Join telehealth video sessions</li>
              </ul>
            </div>
          </div>

          {/* Billing */}
          <div className="flex gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#848974]/10 flex items-center justify-center">
              <CreditCard className="w-4 h-4 text-[#848974]" />
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-900">Billing & Receipts</p>
              <ul className="text-sm text-gray-600 space-y-0.5">
                <li>• View and download payment receipts</li>
                <li>• Manage saved payment methods</li>
              </ul>
            </div>
          </div>

          {/* Forms */}
          <div className="flex gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#848974]/10 flex items-center justify-center">
              <FileText className="w-4 h-4 text-[#848974]" />
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-900">Forms & Records</p>
              <ul className="text-sm text-gray-600 space-y-0.5">
                <li>• Complete intake forms online</li>
                <li>• Access treatment plans & aftercare notes</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-200" />

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          onClick={handleLogin}
          className="flex-1 h-12 bg-[#848974] hover:bg-[#6e7360] text-white"
        >
          <LogIn className="w-5 h-5 mr-2" />
          Sign In
        </Button>
        <Button
          onClick={handleCreateAccount}
          variant="outline"
          className="flex-1 h-12 border-[#848974] text-[#848974] hover:bg-[#848974]/10"
        >
          <UserPlus className="w-5 h-5 mr-2" />
          Create Account
        </Button>
      </div>
    </div>
  )
}

